import React from 'react';
import { Table, Empty, Tooltip ,Tag,Button} from 'antd';

export default function HistorialPago(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Nro',
                        dataIndex: 'nroCouta',
                        key: 'nroCouta',
                        align: 'center'
                    },

                    {
                        title: 'Cuota de Referencia',
                        dataIndex: 'nroPago',
                        key: 'nroPago',
                        align: 'center'
                    },

                    {
                        title: 'Fecha',
                        dataIndex: 'fecha',
                        key: 'fecha'
                    },

                    
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    },
        
                    {
                        title: 'Cuenta',
                        dataIndex: 'cuenta',
                        key: 'cuenta'
                    },
                    {
                        title: 'Nro Operación',
                        dataIndex: 'nroOperacion',
                        key: 'nroOperacion'
                    },
                    {
                        title: 'Moneda',
                        dataIndex: 'moneda',
                        key: 'moneda'
                    },
        
                    {
                        title: 'Monto',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    }
               
    
                ]}
            />
        </div>
    );
}